import React, { useEffect, useState } from 'react';
import HelpBackIcon from './../../../../../images/helpbackicon.png'
import {Link, useNavigate} from 'react-router-dom'

function ReportDownloads() { 
    const [feedback,setFeedback] = useState(false)
    const navigate= useNavigate();

    return (
        <div style={{backgroundImage:`url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/yovww6fxrbmtzfqlpy0z")`,backgroundPositionX:'-1em',backgroundSize:'100%'}}>

        <div style={{         
        display:'flex',
        flexDirection:'column',
        alignItems:'center',
        zIndex:'1',
        height:'9.63em'
        }}/>

        <div style={{
              backgroundColor:'#F9FCFF',
              width:'100%',
              display:'flex',
              flexDirection:'column',
              alignItems:'center',
              paddingBottom:'5.5em',
              minHeight: '72vh', height: 'auto'
        }}>
            <div style={{
                display:'flex',
                flexDirection:'column',
                alignItems:'flex-start',
                width:'70%',
                paddingTop:'2.5em'
            }}>

                <div style={{
                    display:'flex',
                    flexDirection:'row',
                    alignItems:'center',
                    cursor:'pointer'
                   
                }} onClick={()=>{navigate("/help");setFeedback(false)}}>
                    <img src={HelpBackIcon} style={{width:'1.5em',height:'1.5em',marginRight:'0.25em',cursor:'pointer'}}/>
                    <div className="backTxt">Back</div>
                </div>

                <div className="infoHeader">
                Report Downloads
                </div>

                <div className="infoDesc">
                Report downloads are currently only available for Spotify and Itunes. They provide site specific analytic reports for your music that is hosted on their platforms
                </div>

                <div className="infoDescHeader" >
                What information is available in the reports?
                </div>
                <div className="infoDesc">
                Your data will be broken down into the following sections:
                </div>
                <div className="infoDesc"> 
                 &nbsp;&nbsp;&nbsp;&#x2022;&nbsp;&nbsp;&nbsp;Activity Summary
                 </div>
                 <div className="infoDesc"> 
                 &nbsp;&nbsp;&nbsp;&#x2022;&nbsp;&nbsp;&nbsp;Top Tracks
                 </div>
                 <div className="infoDesc"> 
                 &nbsp;&nbsp;&nbsp;&#x2022;&nbsp;&nbsp;&nbsp;Activity by location
                 </div>
                 <div style={{display:'flex',flexDirection:'row'}}>
                    <div className="infoDesc" style={{marginLeft:'2em',marginRight:'0.5em'}}> 
                    &#x25E6;
                    </div>
                    <div className="infoDesc"> 
                    Due to new regulations, Activity by Location is limited to the country only, and may vary due to available geographic data.
                    </div>
                 </div>

                 <div className="infoDesc"> 
                 &nbsp;&nbsp;&nbsp;&#x2022;&nbsp;&nbsp;&nbsp;Unique listeners
                 </div>
                 <div className="infoDesc"> 
                 &nbsp;&nbsp;&nbsp;&#x2022;&nbsp;&nbsp;&nbsp;The device of Listener (mobile or desktop)
                 </div>
                 <div className="infoDesc"> 
                 &nbsp;&nbsp;&nbsp;&#x2022;&nbsp;&nbsp;&nbsp;Play Sources (i.e. playlist, album, artist, saves, searches)
                 </div>
                 <div className="infoDesc"> 
                 &nbsp;&nbsp;&nbsp;&#x2022;&nbsp;&nbsp;&nbsp;Age
                 </div>
                 <div className="infoDesc"> 
                 &nbsp;&nbsp;&nbsp;&#x2022;&nbsp;&nbsp;&nbsp;Top Albums*
                 </div>
                 <div className="infoDesc"> 
                 &nbsp;&nbsp;&nbsp;&#x2022;&nbsp;&nbsp;&nbsp;Top Playlists**
                 </div>
                

                {
                    !feedback &&
                    <div>
                         <div className="infoDesc" style={{marginTop:'6.5em'}}>
                            Was this article helpful?
                            </div>

                            <div style={{display:'flex',flexDirection:'row'}}>
                                <div className="helpfulBtn" onClick={()=>setFeedback(true)}>
                                    YES
                                </div>

                                <div className="helpfulBtn" onClick={()=>setFeedback(true)}>
                                    NO
                                </div>
                            </div>
                    </div>
                }

                {
                    feedback &&
                    
                         <div className="infoDesc" style={{marginTop:'8.5em'}}>
                           Thank you for your feedback
                            </div>

                         
                    
                }
               
            </div>

        </div>
        
        
       
    </div>
    )
}


export default ReportDownloads;